'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  text-decoration: none;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: ', ';\n  line-height: 1.125;\n  appearance: none;\n  cursor: pointer;\n  transition: ', ' box-shadow;\n  box-shadow: 0 2px 4px ', ';\n  border-radius: ', ';\n  border: none;\n\n  ', ';\n\n  &:hover,\n  &:focus {\n    outline: 0;\n    box-shadow: 0 2px 6px\n      ', ';\n  }\n\n  &:active {\n    outline: 0;\n    box-shadow: 0 2px 8px 2px\n      ', ';\n  }\n\n  ', ';\n\n  ', ';\n\n  ', ';\n  ', ';\n'], ['\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  text-decoration: none;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: ', ';\n  line-height: 1.125;\n  appearance: none;\n  cursor: pointer;\n  transition: ', ' box-shadow;\n  box-shadow: 0 2px 4px ', ';\n  border-radius: ', ';\n  border: none;\n\n  ', ';\n\n  &:hover,\n  &:focus {\n    outline: 0;\n    box-shadow: 0 2px 6px\n      ', ';\n  }\n\n  &:active {\n    outline: 0;\n    box-shadow: 0 2px 8px 2px\n      ', ';\n  }\n\n  ', ';\n\n  ', ';\n\n  ', ';\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      transition: ', ' all;\n      will-change: transform;\n      transform: scale(1);\n      &:hover,\n      &:focus {\n        transform: scale(', ');\n      }\n      ', ' {\n        transform: none;\n      }\n    '], ['\n      transition: ', ' all;\n      will-change: transform;\n      transform: scale(1);\n      &:hover,\n      &:focus {\n        transform: scale(', ');\n      }\n      ', ' {\n        transform: none;\n      }\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      &:before {\n        content: \'\xAB\';\n        padding-right: 0.25em;\n      }\n    '], ['\n      &:before {\n        content: \'\xAB\';\n        padding-right: 0.25em;\n      }\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      &:after {\n        content: \'\xBB\';\n        padding-left: 0.25em;\n      }\n    '], ['\n      &:after {\n        content: \'\xBB\';\n        padding-left: 0.25em;\n      }\n    ']);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

var _styledComponents = require('styled-components');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Button = _Box2.default.withComponent('a').extend(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.bold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.shadowColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.pill;
}, function (props) {
  return props.inverted && {
    backgroundColor: (0, _theme.cx)(props.color),
    color: (0, _theme.cx)(props.bg)
  };
}, function (props) {
  return props.inverted ? props.theme.shadowColor : (0, _theme.hexa)(props.bg, 0.25);
}, function (props) {
  return props.inverted ? props.theme.shadowColor : (0, _theme.hexa)(props.bg, 0.25);
}, function (props) {
  return props.disabled && { opacity: 0.25, cursor: 'not-allowed' };
}, function (props) {
  return props.scale && (0, _styledComponents.css)(_templateObject2, function (_ref5) {
    var theme = _ref5.theme;
    return theme.transition;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.scaleFactor;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.mediaQueries.reduceMotion;
  });
}, function (props) {
  return props.chevronLeft && (0, _styledComponents.css)(_templateObject3);
}, function (props) {
  return props.chevronRight && (0, _styledComponents.css)(_templateObject4);
});

Button.displayName = 'Button';

Button.propTypes = {
  /** flip colors */
  inverted: _propTypes2.default.bool,
  /** add hover/focus animation */
  scale: _propTypes2.default.bool,
  /** add left text arrows */
  chevronLeft: _propTypes2.default.bool,
  /** add right text arrows */
  chevronRight: _propTypes2.default.bool
};

Button.defaultProps = {
  theme: _theme2.default,
  bg: 'primary',
  color: 'white',
  fontSize: 3,
  m: 0,
  px: 3,
  py: 2
};

Button.button = Button.withComponent('button');
Button.input = Button.withComponent('input');

exports.default = Button;